<template>
    <el-dialog title="机构简介" :visible.sync="centerDialogVisible" width="600px" :close-on-click-modal="false" class="shopDesc">
        <div class="inputBox">
            <p class="title">机构简介</p>
            <el-input v-model="desc" type="textarea" resize="none" placeholder="请输入机构简介" maxlength="100" show-word-limit></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import {uploadShopMemo} from 'api/accountApi'
export default {
    name: 'shopDesc',
    data() {
        return {
            centerDialogVisible: false,
            desc: ''
        }
    },
    props: ['data'],
    methods: {
        open() {
            this.centerDialogVisible = true
        },
        confirm() {
            if (this.desc) {
                this.setLoading(true)
                uploadShopMemo({
                    data: {shopmemo: this.desc},
                    success: data => {
                        this.setLoading(false)
                        this.$message.success('设置成功')
                        this.centerDialogVisible = false
                        this.$emit('setDesp', this.desc)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            } else {
                this.$message.error('请输入简介')
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    this.desc = newV.shopmemo
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .shopDesc{
        .inputBox{
            display: flex;
            // align-items: center;
            .title{
                margin: 10px 40px 0 16px;
            }
            .el-textarea{
                width: 433px;
                .el-textarea__inner{
                    height: 98px;
                }
            }
        }
    }
</style>